import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Form, Header, Modal } from 'semantic-ui-react';
import {
  closeCreateUserMappingModal,
  createUserMapping,
} from 'state/userMapping/actions';
import {
  idEmptyValidation,
  idNumberValidation,
  emailValidation,
  phoneValidation,
  dateValidation,
} from 'utils/userMappingFormUtils';
import { Field, reduxForm } from 'redux-form';
import ValidatedFormInput from 'components/ValidatedFormInput';

const CreateUserMappingModal = props => {
  const { dispatch, createUserMappingModal, handleSubmit } = props;

  const handleOnCancelButtonClick = () => {
    dispatch(closeCreateUserMappingModal());
  };

  const handleOnSaveButtonClick = ({
    mokaUserId,
    hermesId,
    email,
    phoneNumber,
    confirmedAt,
  }) => {
    const payload = {
      moka_user_id: mokaUserId,
      hermes_id: hermesId,
      email: email !== '' ? email : null,
      phone_number: phoneNumber !== '' ? phoneNumber : null,
      confirmed_at: confirmedAt !== '' ? confirmedAt : null,
    };
    dispatch(createUserMapping(payload));
    dispatch(closeCreateUserMappingModal());
  };

  return (
    <Modal
      as={Form}
      onSubmit={handleSubmit(handleOnSaveButtonClick)}
      closeIcon
      open={createUserMappingModal}
      onClose={handleOnCancelButtonClick}
      size="tiny"
    >
      <Header icon="user" content="Add User Mapping" />
      <Modal.Content>
        <label>Moka User ID</label>
        <Field
          id="mokaUserId"
          name="mokaUserId"
          component={ValidatedFormInput}
          validate={[idEmptyValidation, idNumberValidation]}
          type="number"
        />
        <label>Go User ID</label>
        <Field
          id="hermesId"
          name="hermesId"
          component={ValidatedFormInput}
          validate={[idEmptyValidation, idNumberValidation]}
          type="number"
        />
        <label>Go Email</label>
        <Field
          id="email"
          name="email"
          component={ValidatedFormInput}
          validate={[emailValidation]}
        />
        <label>Go Phone</label>
        <Field
          id="phoneNumber"
          name="phoneNumber"
          component={ValidatedFormInput}
          validate={[phoneValidation]}
        />
        <label>Confirmed At</label>
        <Field
          id="confirmedAt"
          name="confirmedAt"
          component={ValidatedFormInput}
          validate={[dateValidation]}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button
          basic
          type="button"
          color="blue"
          onClick={handleOnCancelButtonClick}
        >
          Cancel
        </Button>
        <Button type="submit" color="blue">
          Save
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const mapStateToProps = ({ userMapping }) => ({
  createUserMappingModal: userMapping.createUserMappingModal,
});

CreateUserMappingModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  createUserMappingModal: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'create_user_mapping_form',
  })(CreateUserMappingModal)
);
